import React, { useState, useEffect } from "react";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { Row, Col, Card, CardBody, Button, Label, Table } from "reactstrap";
import { MDBDataTable } from "mdbreact";
import axios from "axios";
import Select from "react-select";
import accessToken from "../../helpers/jwt-token-access/accessToken";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import moment from "moment";
import toastr from "toastr";
import Pagination from "@mui/material/Pagination";
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx'



function TeacherDetails() {
  const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";
  const [masterObj, setmasterObj] = useState({ start: 1 });
  const [tableDetails, settableDetails] = useState([]);
  const [instituteOptions, setInstituteOptions] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [selectedTeacher, setselectedTeacher] = useState(null);
  const [tecaherOption, settecaherOption] = useState([]);
  const [selectedPayment, setselectedPayment] = useState(null);
  const [dataToBeExported, setDataToBeExported] = useState([]);
  const [selectedSource, setSelectedSource] = useState(null)
  const [exportLoader, setExportLoader] = useState(false);

  const from_date = masterObj?.from_date;
  const to_date = masterObj?.to_date;
  const institute_id = masterObj?.institute_id;
  const teacher_id = masterObj?.teacher_id;
  const joining_from = masterObj?.joining_from;
  const joining_to = masterObj?.joining_to;
  const from_time = masterObj?.from_time;
  const to_time = masterObj?.to_time;
  const payment = masterObj?.payment;
  const created_by = masterObj?.created_by;

  // Pagination
  const [searchValue, setSearchValue] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [PerPageCount, setPerPageCount] = useState(20);
  const [indexOfLastTransfer, setindexOfLastTransfer] = useState(currentPage * PerPageCount)
  const [indexOfFirstTransfer, setindexOfFirstTransfer] = useState(indexOfLastTransfer - PerPageCount)



  function paginate(event, value) {
    // setmasterObj({ ...masterObj, start: value });
    setCurrentPage(value);
    const indexOfLastTransfer = value * PerPageCount;
    const indexOfFirstTransfer = indexOfLastTransfer - PerPageCount;
    setindexOfFirstTransfer(indexOfFirstTransfer)
    setindexOfLastTransfer(indexOfLastTransfer)
    fetchAllAppointed(searchValue, from_date, to_date, institute_id, teacher_id, joining_from, joining_to, from_time, to_time, payment, created_by, value, PerPageCount)
  }

  const resetPaginate = () => {
    setCurrentPage(1)
    const indexOfLastTransfer = 20;
    const indexOfFirstTransfer = 0;
    setindexOfFirstTransfer(indexOfFirstTransfer);
    setindexOfLastTransfer(indexOfLastTransfer);
  }

  const handleSearch = (value) => {
    setSearchValue(value)
    resetPaginate()
    fetchAllAppointed(value, from_date, to_date, institute_id, teacher_id, joining_from, joining_to, from_time, to_time, payment, created_by)
  }

  useEffect(() => {
    if (tableDetails?.length === 0 && indexOfFirstTransfer !== 0) {
      resetPaginate();
      fetchAllAppointed(searchValue, from_date, to_date, institute_id, teacher_id, joining_from, joining_to, from_time, to_time, payment, created_by, currentPage, PerPageCount);
    }
  }, []);


  useEffect(() => {
    fetchAllTeachers();
    fetchAllAppointed(searchValue)
  }, [currentPage]);


  useEffect(() => {
    // fetchAllAppointed();
    fetch_all_institute();
  }, [masterObj]);



  function fetchAllTeachers() {
    axios
      .get(`${API_URL}candidate/appointed/teachers-options`, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let result = res.data.data;
        let techOpt =
          result &&
          result.map((item, index) => {
            let exportItem = {};
            return {
              label: item.placed_cand_name,
              value: item.placed_cand_id,
            };
          });
        settecaherOption(techOpt);
      });
  }

  const fetch_all_institute = () => {
    axios
      .get(`${API_URL}institute/options`, {
        headers: {
          "x-access-token": accessToken,
        },
      })
      .then((res) => {
        let institute_data =
          res.data.data &&
          res.data.data.map((el) => {
            return {
              label: el?.inst_reg_no + "-" + el?.inst_name,
              value: el?._id,
              whatsapp: el?.inst_whatsapp_no,
              displayLabel: el?.inst_name,
            };
          });
        setInstituteOptions([
          {
            options: institute_data,
          },
        ]);
      });
  };
  const data = {
    columns: [
      {
        label: "#",
        field: "id",
        sort: "asc",
        width: 150,
      },
      {
        label: "Date",
        field: "date1",
        sort: "asc",
        width: 150,
      },
      {
        label: "Time",
        field: "time1",
        sort: "asc",
        width: 150,
      },
      {
        label: "Institute",
        field: "instname",
        sort: "asc",
        width: 150,
      },
      {
        label: "Teacher",
        field: "techername",
        sort: "asc",
        width: 150,
      },
      {
        label: "Joining Date",
        field: "joindate",
        sort: "asc",
        width: 150,
      },
      {
        label: "Salary",
        field: "salary",
        sort: "asc",
        width: 150,
      },
      {
        label: "Charges",
        field: "service_charge",
        sort: "asc",
        width: 150,
      },
      {
        label: "Payment",
        field: "payment",
        sort: "asc",
        width: 150,
      },
      {
        label: "Remark",
        field: "remarkfield",
        sort: "asc",
        width: 150,
      },
    ],
    rows: tableDetails,
  };

  let handleDate = (e) => {
    if (e.target.name == "from_date") {
      var date1 = e.target.value;
      var date2 = masterObj?.to_date;
    } else {
      var date1 = masterObj?.from_date;
      var date2 = e.target.value;
    }
    const institute_id = masterObj?.institute_id;
    const teacher_id = masterObj?.teacher_id;
    const joining_from = masterObj?.joining_from;
    const joining_to = masterObj?.joining_to;
    const from_time = masterObj?.from_time;
    const to_time = masterObj?.to_time;
    const payment = masterObj?.payment;
    const created_by = masterObj?.created_by;

    let toDate = moment(date1);
    let fromDate = moment(date2);
    let result = fromDate.diff(toDate, "days");

    if (result + 1 <= 0) {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
        ["to_date"]: "",
      });
      date2 = "";
    } else {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
      });
    }
    resetPaginate();
    fetchAllAppointed(
      searchValue,
      date1,
      date2,
      institute_id,
      teacher_id,
      joining_from,
      joining_to,
      from_time,
      to_time,
      payment,
      created_by,
    );
  };

  function hnadletime(e) {
    if (e.target.name == "from_time") {
      var time1 = e.target.value;
      var time2 = masterObj?.to_time;
    } else {
      var time1 = masterObj?.from_time;
      var time2 = e.target.value;
    }
    const institute_id = masterObj?.institute_id;
    const teacher_id = masterObj?.teacher_id;
    const joining_from = masterObj?.joining_from;
    const joining_to = masterObj?.joining_to;
    const from_date = masterObj?.from_date;
    const to_date = masterObj?.to_date;
    const payment = masterObj?.payment;
    const created_by = masterObj?.created_by;

    let toTime = moment(time1);
    let fromTime = moment(time2);
    let result = fromTime.diff(toTime, "days");

    if (result + 1 <= 0) {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
        ["to_time"]: "",
      });
      time2 = "";
    } else {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
      });
    }
    resetPaginate();
    fetchAllAppointed(
      searchValue,
      from_date,
      to_date,
      institute_id,
      teacher_id,
      joining_from,
      joining_to,
      time1,
      time2,
      payment,
      created_by,
    );
  }

  function hnadleJoin(e) {
    if (e.target.name == "joining_from") {
      var join1 = e.target.value;
      var join2 = masterObj?.joining_to;
    } else {
      var join1 = masterObj?.joining_from;
      var join2 = e.target.value;
    }
    const institute_id = masterObj?.institute_id;
    const teacher_id = masterObj?.teacher_id;
    const from_time = masterObj?.from_time;
    const to_time = masterObj?.to_time;
    const from_date = masterObj?.from_date;
    const to_date = masterObj?.to_date;
    const payment = masterObj?.payment;
    const created_by = masterObj?.created_by;

    let toJoin = moment(join1);
    let fromJoin = moment(join2);
    let result = fromJoin.diff(toJoin, "days");

    if (result + 1 <= 0) {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
        ["joining_to"]: "",
      });
      join2 = "";
    } else {
      setmasterObj({
        ...masterObj,
        [e.target.name]: e.target.value,
      });
    }
    resetPaginate();
    fetchAllAppointed(
      searchValue,
      from_date,
      to_date,
      institute_id,
      teacher_id,
      join1,
      join2,
      from_time,
      to_time,
      payment,
      created_by,
    );
  }


  function handlechangeStatus(item, num) {
    if (num == 0) {
      axios
        .post(
          `${API_URL}candidate/appointed/teachers/paymentstatus`,
          {
            type: 1,
            _id: item,
            value: 1,
          },
          {
            headers: {
              "x-access-token": accessToken,
            },
          }
        )
        .then((res) => {
          toastr.success("payment status changed to Paid");
          fetchAllAppointed();
        });
    } else if (num == 1) {
      axios
        .post(
          `${API_URL}candidate/appointed/teachers/paymentstatus`,
          {
            type: 1,
            _id: item,
            value: 2,
          },
          {
            headers: {
              "x-access-token": accessToken,
            },
          }
        )
        .then((res) => {
          toastr.success("payment status changed to Due");
          fetchAllAppointed();
        });
    } else if (num == 2) {
      axios
        .post(
          `${API_URL}candidate/appointed/teachers/paymentstatus`,
          {
            type: 1,
            _id: item,
            value: 3,
          },
          {
            headers: {
              "x-access-token": accessToken,
            },
          }
        )
        .then((res) => {
          toastr.success("payment status changed to Cancel");
          fetchAllAppointed();
        });
    }else if(num==3){
      axios
      .post(
        `${API_URL}candidate/appointed/teachers/paymentstatus`,
        {
          type: 1,
          _id: item,
          value: 0,
        },
        {
          headers: {
            "x-access-token": accessToken,
          },
        }
      )
      .then((res) => {
        toastr.success("payment status changed to Pending");
        fetchAllAppointed();
      });

    }
  }

  function handleBlurRemark(id, e) {
    let data = e.target.value;
    axios
      .post(
        `${API_URL}candidate/appointed/teachers/paymentstatus`,
        {
          _id: id,
          type: 2,
          value: data,
        },
        {
          headers: {
            "x-access-token": accessToken,
          },
        }
      )
      .then((res) => {
      });
  }

  function fetchAllAppointed(
    searchValue = "",
    from_date = "",
    to_date = "",
    institute_id = "",
    teacher_id = "",
    joining_from = "",
    joining_to = "",
    from_time = "",
    to_time = "",
    payment = "",
    created_by = "",
    start = currentPage,
    limit = 20,
  ) {
    var url = `${API_URL}candidate/appointed/teachers`;

    url =
      url +
      "?searchValue=" +
      searchValue +
      "&from_date=" +
      from_date +
      "&to_date=" +
      to_date +
      "&institute_id=" +
      institute_id +
      "&teacher_id=" +
      teacher_id +
      "&joining_from=" +
      joining_from +
      "&joining_to=" +
      joining_to +
      "&from_time=" +
      from_time +
      "&to_time=" +
      to_time +
      "&payment=" +
      payment +
      "&created_by=" +
      created_by +
      "&start=" +
      start +
      "&limit=" +
      limit;

    axios
      .get(url, {
        headers: {
          "x-access-token": accessToken,
        },
      }
      )
      .then((res) => {
        let result = res?.data?.data;
        let dataToBeExported = [];
        let id = (start - 1) * limit;
        setTotalPages(res.data.count);
        let data = [];
        result?.map((item, index) => {
          id++;
          item.id = id;
          let exportItem = {};
          item.joindate = moment(item?.joining_date).format("DD-MM-YYYY");
          item.instname = (
            <div>
              <a
                style={{ cursor: "pointer" }}
                target="blank"
                href={"/institute/" + item?.institute_regno}
              >
                {item?.institute_name}
              </a>
            </div>
          );

          item.techername = (
            <div>
              <a
                style={{ cursor: "pointer" }}
                target="blank"
                href={"/candidate/" + item?.teacher_regno}
              >
                {item?.teacher_name}
              </a>
            </div>
          );
          item.date1 = moment(item.appointed_date).format("DD-MM-YYYY");
          item.time1 = moment(item.appointed_time, "HH:mm s").format("hh:mm a");
          item.remarkfield = (
            <div>
              <AvForm>
                <AvField
                  rows="1"
                  name="remarks"
                  type="textarea"
                  value={item.remarks}
                  onBlur={(e) => {
                    handleBlurRemark(item._id, e);
                  }}
                />
              </AvForm>
            </div>
          );
          if (item.payment_status == 1) {
            item.payment = (
              <div>
                <Button
                  onClick={() => {
                    handlechangeStatus(item._id, 1);
                  }}
                  style={{
                    padding: "0px 5px",
                    width: "50px",
                    fontSize: ".7rem",
                  }}
                  color="success"
                >
                  Paid
                </Button>
              </div>
            );
          } else if (item.payment_status == 0) {
            item.payment = (
              <div>
                <Button
                  onClick={() => {
                    handlechangeStatus(item._id, 0);
                  }}
                  style={{
                    padding: "0px 5px",
                    width: "50px",
                    fontSize: ".7rem",
                  }}
                  color="warning"
                >
                  Pending
                </Button>
              </div>
            );
          } else if (item.payment_status == 2) {
            item.payment = (
              <div>
                <Button
                  onClick={() => {
                    handlechangeStatus(item._id, 2);
                  }}
                  style={{
                    padding: "0px 5px",
                    width: "50px",
                    fontSize: ".7rem",
                  }}
                  color="danger"
                >
                  Due
                </Button>
              </div>
            );
          }else if(item.payment_status==3){
            item.payment=(
              <div>
              <Button
                onClick={() => {
                  handlechangeStatus(item._id, 3);
                }}
                style={{
                  padding: "0px 5px",
                  width: "50px",
                  fontSize: ".7rem",
                }}
                color="primary"
              >
                Cancelled
              </Button>
            </div>

            )
          }

          data.push(item);
          // exportItem.Id = item.id;
          // exportItem.AppintedDate = item.date1;
          // exportItem.AppointedTime = item.time1;
          // exportItem.Institute = item.institute_name;
          // exportItem.Candidate = item.teacher_name;
          // exportItem.JoiningDate = item.joindate;
          // exportItem.Salary = item.salary;
          // exportItem.Charges = item.service_charge;
          // if (item.payment_status == 0) {
          //   exportItem.PaymentStatus = "Pending"
          // }
          // if (item.payment_status == 1) {
          //   exportItem.PaymentStatus = "Paid"
          // }
          // if (item.payment_status == 2) {
          //   exportItem.PaymentStatus = "Due"
          // }
          // exportItem.Remarks = item.remarks;


          dataToBeExported.push(exportItem);
        });
        settableDetails(data);
        setDataToBeExported(dataToBeExported);

        // handleApiExport(searchValue, from_date, to_date, institute_id, teacher_id, joining_from, joining_to, from_time, to_time, payment, created_by)

      });
  }

  function handleChange(selected, name) {
    let institute_id = masterObj?.institute_id ? masterObj.institute_id : "";
    let teacher_id = masterObj?.teacher_id ? masterObj.teacher_id : "";
    let payment = masterObj?.payment ? masterObj.payment : "";
    let from_date = masterObj?.from_date ? masterObj.from_date : "";
    let to_date = masterObj?.to_date ? masterObj.to_date : "";
    let from_time = masterObj?.from_time ? masterObj.from_time : "";
    let to_time = masterObj?.to_time ? masterObj.to_time : "";
    let joining_from = masterObj?.joining_from ? masterObj.joining_from : "";
    let joining_to = masterObj?.joining_to ? masterObj.joining_to : "";
    let created_by = selectedSource?.value ? selectedSource?.value : "";

    resetPaginate();
    switch (name) {
      case "institute":
        setSelectedInstitute(selected);
        setmasterObj({ ...masterObj, institute_id: selected.value });
        fetchAllAppointed(
          searchValue,
          from_date,
          to_date,
          selected.value,
          teacher_id,
          joining_from,
          joining_to,
          from_time,
          to_time,
          payment,
          created_by
        )
        break;
      case "teacher":
        setselectedTeacher(selected);
        setmasterObj({ ...masterObj, teacher_id: selected.value });
        fetchAllAppointed(
          searchValue,
          from_date,
          to_date,
          institute_id,
          selected.value,
          joining_from,
          joining_to,
          from_time,
          to_time,
          payment,
          created_by
        )
        break;
      case "payment":
        setselectedPayment(selected);
        setmasterObj({ ...masterObj, payment: selected.value });
        fetchAllAppointed(
          searchValue,
          from_date,
          to_date,
          institute_id,
          teacher_id,
          joining_from,
          joining_to,
          from_time,
          to_time,
          selected.value,
          created_by
        )
        break;
      case "created_by":
        setSelectedSource(selected)
        setmasterObj({ ...masterObj, created_by: selected.value });
        fetchAllAppointed(
          searchValue,
          from_date,
          to_date,
          institute_id,
          teacher_id,
          joining_from,
          joining_to,
          from_time,
          to_time,
          payment,
          selected.value
        )
        break;
      default:
        break;
    }
  }


  // function handleApiCall() {
  //   axios.post(`${API_URL}institute/log/creation`, { type: 1 }, {
  //     headers: {
  //       "x-access-token": accessToken
  //     }
  //   }).then((res) => {
  //   })
  // }

  const reset = () => {
    setSelectedInstitute(null)
    setselectedTeacher(null)
    setselectedPayment(null)
    setSelectedSource(null)
    fetchAllAppointed()
    setmasterObj({
      from_date: "",
      to_date: "",
      from_time: "",
      to_time: "",
      joining_from: "",
      joining_to: ""
    })
    resetPaginate();
  }

  const handleApiCall = async (
    // searchValue = searchValue || "",
    valuesearch=searchValue||"",
    to_date = masterObj?.to_date || "",
    institute_id = masterObj?.institute_id || "",
    teacher_id = masterObj?.teacher_id || "",
    joining_from = masterObj?.joining_from || "",
    joining_to = masterObj?.joining_to || "",
    from_time = masterObj?.from_time || "",
    to_time = masterObj?.to_time || "",
    payment = masterObj?.payment || "",
    created_by = masterObj?.created_by || "",
  ) => {
    setExportLoader(true)

    var url = `${API_URL}candidate/appointed/teachers/export`;

    url =
      url +
      "?search=" +
      valuesearch +
      "&from_date=" +
      from_date +
      "&to_date=" +
      to_date +
      "&institute_id=" +
      institute_id +
      "&teacher_id=" +
      teacher_id +
      "&joining_from=" +
      joining_from +
      "&joining_to=" +
      joining_to +
      "&from_time=" +
      from_time +
      "&to_time=" +
      to_time +
      "&payment=" +
      payment +
      "&created_by=" +
      created_by;
    let dataToBeExported = [];

    await axios
      .get(url, {
        headers: {
          "x-access-token": accessToken,
        },
      }).then(res => {
        let result = res.data.data;
        result &&
          result.map((el, indx) => {

            let exportItem = {};
            exportItem.Id = indx + 1;
            exportItem.AppintedDate = moment(el.appointed_date).format("DD-MM-YYYY");
            exportItem.AppointedTime = moment(el.appointed_time, "hh:mm s").format("hh:mm a");
            exportItem.Institute = el.institute_name;
            exportItem.Candidate = el.teacher_name;
            exportItem.JoiningDate = moment(el.joining_date).format("DD-MM-YYYY");
            exportItem.Salary = el.salary;
            exportItem.Charges = el.service_charge;
            exportItem.Payment_Status = el.payment_status === 0 ? "Pending"
              : el.payment_status === 1 ? "Paid"
                : el.payment_status === 2 ? "Due" : "";

            dataToBeExported.push(exportItem)
          })
        // setDataToBeExported(dataToBeExported)
        setExportLoader(false)
      })
    return dataToBeExported

  }

  const jsonToExcel = (
    jsonArray,
    sheetName = moment().format("DDMMYYhhmmss")
  ) => {
    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(jsonArray)

    // Create a workbook
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, sheetName)

    // Save to a file
    XLSX.writeFile(wb, `${sheetName}.xlsx`)
  }

  async function handleExport() {
    const data = await handleApiCall()

    jsonToExcel(data, `appointed candidate`)
  }


  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Appointed Candidate" />
          <Row>
            <Card>
              <CardBody>
                <Row>
                  <Col md="12">
                    <AvForm>
                      <Row>
                        <Col md="3">
                          <div className="mb-3">
                            <Label>Institute </Label>
                            <Select
                              name="institute"
                              value={selectedInstitute}
                              onChange={(selected) =>
                                handleChange(selected, "institute")
                              }
                              options={instituteOptions}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </Col>

                        <Col md="2">
                          <div className="mb-3">
                            <Label>Teacher </Label>
                            <Select
                              name="teacher"
                              value={selectedTeacher}
                              onChange={(selected) =>
                                handleChange(selected, "teacher")
                              }
                              options={tecaherOption}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="mb-3">
                            <Label>From Date</Label>
                            <AvField
                              type="date"
                              name="from_date"
                              onChange={handleDate}
                              value={masterObj?.from_date}
                            />
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="mb-3">
                            <Label>To Date</Label>
                            <AvField
                              type="date"
                              name="to_date"
                              onChange={handleDate}
                              value={masterObj?.to_date}
                            />
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="mb-3">
                            <Label>From Time</Label>
                            <AvField
                              name="from_time"
                              type="time"
                              onChange={(e) => {
                                hnadletime(e);
                              }}
                              value={masterObj?.from_time}
                            />
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="mb-3">
                            <Label>To Time</Label>
                            <AvField
                              name="to_time"
                              type="time"
                              onChange={(e) => {
                                hnadletime(e);
                              }}
                              value={masterObj?.to_time}
                            />
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="mb-3">
                            <Label>Joining Date from</Label>
                            <AvField
                              name="joining_from"
                              type="date"
                              onChange={(e) => {
                                hnadleJoin(e);
                              }}
                              value={masterObj?.joining_from}
                            />
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="mb-3">
                            <Label>Joining Date to</Label>
                            <AvField
                              name="joining_to"
                              type="date"
                              onChange={(e) => {
                                hnadleJoin(e);
                              }}
                              value={masterObj?.joining_to}
                              min={masterObj.joining_from}
                            />
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="mb-3">
                            <Label>Payment Status</Label>
                            <Select
                              rows={1}
                              options={[
                                { label: "Paid", value: 1 },
                                { label: "Pending", value: 0 },
                                { label: "Due", value: 2 },
                              ]}
                              onChange={(selected) =>
                                handleChange(selected, "payment")
                              }
                              value={selectedPayment}
                            />
                          </div>
                        </Col>
                        <Col md="2">
                          <div className="mb-3">
                            <Label>Source</Label>
                            <Select
                              name="created_by"
                              options={[
                                { label: "Crm", value: 0 },
                                { label: "Web", value: 1 },
                                { label: "App", value: 2 },
                              ]}
                              onChange={(selected) =>
                                handleChange(selected, "created_by")
                              }
                              value={selectedSource}
                            />
                          </div>
                        </Col>
                        <Col md="1">
                          <div className="mt-4" style={{ paddingTop: "6px", display: "flex" }}>
                            <Button onClick={() => handleExport()} disabled={exportLoader ? "disabled" : ""} color="success" type="">
                              {/* <CSVLink
                            data={dataToBeExported}
                            filename={"Appregistered.xls"}
                            style={{ color: "white" }}
                          >
                            Export

                          </CSVLink> */}
                              Export
                            </Button>

                            <Button color="danger" type="submit" onClick={() => reset()} style={{ marginLeft: "25px" }}>Reset</Button>
                          </div>
                        </Col>
                      </Row>
                    </AvForm>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <MDBDataTable
                      id="subscriptionstable"
                      responsive
                      bordered
                      data={data}
                      info={false}
                      searching={true}
                      entries={PerPageCount}
                      disableRetreatAfterSorting={true}
                      paging={false}
                      onSearch={(value) => handleSearch(value)}
                    />
                    {totalPages > 20 && (
                      <div
                        className="pagination-div">
                        <div className="page-details">
                          Showing {((currentPage - 1) * PerPageCount) + 1} to{" "}
                          {Math.min(currentPage * PerPageCount, totalPages)} of{" "}
                          {totalPages} entries
                        </div>
                        <Pagination
                          color="standard"
                          shape="rounded"
                          defaultPage={1}
                          count={Math.ceil(totalPages / PerPageCount)}
                          page={currentPage}
                          onChange={paginate}
                          size="large"
                          info={true}
                        />
                      </div>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Row>
        </div>
      </div>
    </>
  );
}
export default TeacherDetails;
